import { render, staticRenderFns } from "./PoiInformation.vue?vue&type=template&id=46ff824c"
import script from "./PoiInformation.vue?vue&type=script&lang=js"
export * from "./PoiInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports